import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from "lucide-react";
import { ASSETS, ALL_NAV, CONTACT } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-rda-ink text-white/85">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          {/* About */}
          <div>
            <div className="flex items-center gap-3">
              <img
                src={ASSETS.logo}
                alt="RDA Glasgow logo"
                className="h-11 w-11 rounded-xl object-cover"
              />
              <span className="font-heading font-extrabold text-lg text-white">
                RDA Glasgow
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/70 max-w-xs">
              Improving lives, one ride at a time — providing equine therapy for
              disabled people across Greater Glasgow.
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { Icon: Facebook, label: "Facebook" },
                { Icon: Instagram, label: "Instagram" },
                { Icon: Twitter, label: "Twitter" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-rda-teal transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-heading font-bold text-white text-base">Quick Links</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2">
              {ALL_NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                    data-testid={`footer-link-${item.to.slice(1)}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-bold text-white text-base">Contact</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/75">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-rda-teal shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-0.5 text-rda-teal shrink-0" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors" data-testid="footer-phone">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-rda-teal shrink-0" />
                <span data-testid="footer-address">{CONTACT.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5">
          <p className="text-xs text-white/60 text-center md:text-left" data-testid="footer-charity-line">
            © 2026 Glasgow Riding for the Disabled Association · Scottish Charity No. {CONTACT.charityNo}
          </p>
        </div>
      </div>
    </footer>
  );
};
